import React, { useEffect, useState } from 'react';

import { Input, Label } from 'reactstrap';

const SCALE_OPTIONS = [
  { value: 1, label: 'Discordo totalmente' },
  { value: 2, label: 'Discordo' },
  { value: 3, label: 'Neutro' },
  { value: 4, label: 'Concordo' },
  { value: 5, label: 'Concordo totalmente' },
];

export default function AgreeDisagreeDisplay({ attributes, rowId, colId, setValue }) {
  const [selected, setSelected] = useState(attributes.value ?? null);

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = selected;
      newValue[rowId].cols[colId].attributes.errorMessage =
        !selected && attributes.required ? 'Selecione uma opção' : '';
      return newValue;
    });
  }, [selected, setValue, rowId, colId, attributes.required]);

  return (
    <div className="custom-input-container">
      <div className="displayed-label">
        <span>{attributes.ask}{attributes.required && '*'}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
        {SCALE_OPTIONS.map((opt) => (
          <div
            key={opt.value}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, cursor: 'pointer' }}
            onClick={() => setSelected(opt.label)}
          >
            <Input
              type="radio"
              name={`agree-${rowId}-${colId}`}
              checked={selected === opt.label}
              onChange={() => setSelected(opt.label)}
              style={{ margin: '0 auto 4px', cursor: 'pointer' }}
            />
            <Label
              style={{ textAlign: 'center', fontSize: '11px', lineHeight: '1.2', cursor: 'pointer', marginBottom: 0 }}
            >
              {opt.label}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
}
